module.exports = __webpack_public_path__ + "img/saishi1.841ca159.svg";